// src/redux/lib/helper.ts
import { toastService } from '@/utils/toastService';

export const normalizeErrorMessage = (error: any): string => {
    return (
        error?.data?.message ||
        error?.error ||
        error?.message ||
        (typeof error === 'string' ? error : '')
    );
};

export const normalizeSuccessMessage = (response: any): string => {
    return (
        response?.message ||
        (typeof response === 'string' ? response : '')
    );
};

type ResponseResult = {
    isSuccess?: boolean;
    isError?: boolean;
    data?: any;
    error?: any;
};

type HandleApiResponseOptions = {
    result: ResponseResult;
    customSuccessMessage?: string;
    customErrorMessage?: string;
    showSuccessToast?: boolean;
    showErrorToast?: boolean;
};

export const handleApiResponse = ({
    result,
    customSuccessMessage,
    customErrorMessage,
    showSuccessToast = true,
    showErrorToast = true,
}: HandleApiResponseOptions): void => {
    if (result?.isSuccess && showSuccessToast) {
        const apiMsg = normalizeSuccessMessage(result?.data);
        const message = apiMsg || customSuccessMessage;
        if (message) toastService.success(message);
    }

    if (result?.isError && showErrorToast) {
        const apiErrorMsg = normalizeErrorMessage(result?.error);
        const message = apiErrorMsg || customErrorMessage;
        toastService.error(message!);
    }
};

export const buildQuery = <TRequest = void>(
    url: string,
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'GET'
) => {
    return (payload?: TRequest) => ({
        url,
        method,
        ...(payload && { body: payload }),
    });
};

export const buildQueryWithParams = <TRequest = void>(
    url: string,
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'GET'
) => {
    return (params?: TRequest) => {
        if (method === 'GET' && params) {
            const queryString = new URLSearchParams(params as any).toString();
            return {
                url: `${url}${queryString ? `?${queryString}` : ''}`,
                method,
            };
        }
        return {
            url,
            method,
            ...(params && { body: params }),
        };
    };
};
